// Шалгалт (сурагч): онлайн тестүүдийн жагсаалт — нээгдэх/хаагдах хугацаа, хугацааны хязгаар, миний төлөв, оноо (зөвшөөрсөн үед).
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Spin } from "antd";
import { FiCheckCircle, FiChevronRight, FiClock, FiEdit3, FiLock } from "react-icons/fi";
import { instance } from "utils/axios";
import { fmtWhen, scoreText } from "./common";

const statusOf = (e) => {
  const a = e.attempt;
  if (a?.status === "in_progress") return { label: "Үргэлжлүүлэх", cls: "bg-amber-50 text-amber-800", icon: FiEdit3 };
  if (a) return { label: "Илгээсэн", cls: "bg-emerald-50 text-emerald-700", icon: FiCheckCircle };
  if (e.state === "open") return { label: "Нээлттэй", cls: "bg-primary/10 text-primary", icon: FiEdit3 };
  if (e.state === "upcoming") return { label: "Удахгүй", cls: "bg-blue-50 text-blue-700", icon: FiClock };
  return { label: "Хаагдсан", cls: "bg-gray-100 text-gray-500", icon: FiLock };
};

function ExamCard({ e }) {
  const s = statusOf(e);
  const Icon = s.icon;
  return (
    <Link to={`/exams/${e.id}`} className="pcard flex items-center gap-3 p-3.5 text-gray-900 hover:text-gray-900">
      <span className={`h-11 w-11 rounded-xl flex items-center justify-center shrink-0 ${s.cls}`}><Icon size={20} /></span>
      <span className="flex-1 min-w-0">
        <span className="block text-xs font-semibold text-primary">{e.course?.name}</span>
        <span className="block text-sm font-bold leading-snug mt-0.5">{e.name}</span>
        <span className="block text-xs text-gray-500 mt-1">
          {e.state === "upcoming" && e.opensAt ? `Нээгдэх: ${fmtWhen(e.opensAt)}` : e.closesAt ? `Хаагдах: ${fmtWhen(e.closesAt)}` : "Хугацаагүй"}
          {e.timeLimitMin ? ` · ${e.timeLimitMin} мин` : ""} · {e.questionCount} асуулт
        </span>
      </span>
      <span className="flex flex-col items-end gap-1 shrink-0">
        <span className={`text-xs font-semibold rounded-full px-2 py-0.5 ${s.cls}`}>{s.label}</span>
        {e.result && <span className="text-sm font-bold text-gray-900">{scoreText(e.result)}</span>}
      </span>
      <FiChevronRight className="text-gray-300 shrink-0" />
    </Link>
  );
}

export default function Exams() {
  const [data, setData] = useState(null);
  useEffect(() => {
    instance({ method: "get", url: "/student/exams" }).then((r) => setData(r.data)).catch(() => setData({ exams: [] }));
  }, []);

  const exams = data?.exams || [];
  const active = exams.filter((e) => e.attempt?.status === "in_progress" || (!e.attempt && e.state !== "closed"));
  const done = exams.filter((e) => !active.includes(e));

  return (
    <div className="pt-4 md:pt-6 pb-6 max-w-3xl mx-auto flex flex-col gap-4">
      <div>
        <h1 className="ptitle">Шалгалт</h1>
        <p className="psub">Онлайн тест, сорил</p>
      </div>
      {!data ? <div className="flex justify-center py-10"><Spin /></div> : !exams.length ? (
        <section className="pcard pcard-pad text-center py-10 text-gray-400 text-sm">Одоогоор онлайн тест алга</section>
      ) : (
        <>
          {active.length > 0 && (
            <section className="flex flex-col gap-2.5">
              <h2 className="text-base font-bold text-gray-900 mt-1">Өгөх</h2>
              {active.map((e) => <ExamCard key={e.id} e={e} />)}
            </section>
          )}
          {done.length > 0 && (
            <section className="flex flex-col gap-2.5">
              <h2 className="text-base font-bold text-gray-900 mt-1">Өгсөн / хаагдсан</h2>
              {done.map((e) => <ExamCard key={e.id} e={e} />)}
            </section>
          )}
        </>
      )}
    </div>
  );
}
